import moment from 'moment';

const namespaced = true;

export const getters = {
  humanReadableValue: state => {
    const suffix = state.key.split('__')[1];

    switch (suffix) {
      case 'lt':
        return `before ${moment(state.value).format('D MMM YYYY')}`;
      case 'gt':
        return `after ${moment(state.value).format('D MMM YYYY')}`;
      case 'isnull':
        return 'is empty';
      default:
        return null;
    }
  },
};

export const actions = {
  UPDATE_FILTER: ({ commit }, { slug, date = null }) => {
    const keyBase = 'last_login';
    let key;
    let value;

    switch (slug) {
      case 'before':
        key = `${keyBase}__lt`;
        value = date;
        break;
      case 'after':
        key = `${keyBase}__gt`;
        value = date;
        break;
      case 'empty':
        key = `${keyBase}__isnull`;
        value = true;
        break;
      default:
        key = keyBase;
        value = null;
    }

    commit('SET_KEY', { key });
    commit('SET_VALUE', { value });
  },
};

export const mutations = {
  SET_VALUE(state, { value }) {
    state.value = value;
  },

  SET_DATE(state, { date }) {
    state.date = date;
  },

  SET_KEY(state, { key }) {
    state.key = key;
  },
};

const state = {
  key: 'last_login',
  name: 'Last Login Date',
  options: [
    {
      name: 'After',
      value: 'after',
      type: 'date',
    },
    {
      name: 'Before',
      value: 'before',
      type: 'date',
    },
    {
      name: 'Is empty',
      value: 'empty',
    },
    {
      name: 'Has any value',
      value: 'any',
    },
  ],
  value: 'any',
};

export default {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
